import { AxiosError, AxiosResponse } from 'axios';
import { RESPONSE_CODES } from '../constants/responseCodes.constants';
import { api } from '../http';
import { store } from '../store';
import { DefaultRes } from '../types';
import { SystemConstantsTypes } from '../types/system-constants.types';

export class SystemConstantsService {
    /**
     * Fetch all system constants as key-value pairs
     */
    public static async getAllConstants(
        callback?: (isValid?: boolean, message?: string) => void
    ): Promise<SystemConstantsTypes.SystemConstantsKeyValue | void> {
        try {
            const { data: { result, isValid, message } } = await api.get<
                DefaultRes<SystemConstantsTypes.SystemConstantsKeyValue>,
                AxiosResponse<DefaultRes<SystemConstantsTypes.SystemConstantsKeyValue>>
            >('/system/constants');

            callback && callback(isValid, RESPONSE_CODES[message]);
            return result;
        } catch (error: any) {
            if (error.response) {
                const ERROR_CODE = (error as AxiosError<
                    DefaultRes<SystemConstantsTypes.SystemConstantsKeyValue>
                >).response?.data?.message;
                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }
            callback && callback(false, String(error));
        }
    }

    /**
     * Fetch a single system constant by key
     */
    public static async getConstant(
        key: string,
        callback?: (isValid?: boolean, message?: string) => void
    ): Promise<{ key: string; value: string } | void> {
        try {
            const { data: { result, isValid, message } } = await api.get<
                DefaultRes<{ key: string; value: string }>,
                AxiosResponse<DefaultRes<{ key: string; value: string }>>
            >(`/system/constants/${key}`);

            callback && callback(isValid, RESPONSE_CODES[message]);
            return result;
        } catch (error: any) {
            if (error.response) {
                const ERROR_CODE = (error as AxiosError<
                    DefaultRes<{ key: string; value: string }>
                >).response?.data?.message;
                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }
            callback && callback(false, String(error));
        }
    }

    /**
     * Fetch the minimum app version (with customer override support)
     * Also updates the customer store with the value
     */
    public static async getMinAppVersion(
        callback?: (isValid?: boolean, message?: string) => void
    ): Promise<SystemConstantsTypes.GetMinAppVersionResponse | void> {
        try {
            const { data: { result, isValid, message } } = await api.get<
                DefaultRes<SystemConstantsTypes.GetMinAppVersionResponse>,
                AxiosResponse<DefaultRes<SystemConstantsTypes.GetMinAppVersionResponse>>
            >('/system/minAppVersion');

            if (isValid && result) {
                store.dispatch.customer.setMinAppVersion(result.minAppVersion);
            }

            callback && callback(isValid, RESPONSE_CODES[message]);
            return result;
        } catch (error: any) {
            if (error.response) {
                const ERROR_CODE = (error as AxiosError<
                    DefaultRes<SystemConstantsTypes.GetMinAppVersionResponse>
                >).response?.data?.message;
                callback && callback(false, RESPONSE_CODES[ERROR_CODE!]);
            }
            callback && callback(false, String(error));
        }
    }
}
